// import { List, Stack, useTheme } from '@mui/material';
// import { useAuthContext } from 'src/auth/useAuthContext';

// import { NavSectionProps } from '../types';

// import NavList from './NavList';

// // ----------------------------------------------------------------------

// export default function NavSectionVertical({ data, sx, ...other }: NavSectionProps) {
//   const { user } = useAuthContext();

//   const theme = useTheme();
//   const ACCESSIBLE_MENU_URI_LIST = user?.menuList.map((m: any) => m.menuUri);

//   return (
//     <Stack sx={sx} {...other}>
//       {data.map((group) => {
//         const key = group.subheader || group.items[0].title;

//         return (
//           group.items
//             .map((list) => ACCESSIBLE_MENU_URI_LIST.includes(list.path))
//             .includes(true) && (
//             <List
//               key={key}
//               disablePadding
//               sx={{ px: 2, ml: 1, mr: 1, borderBottom: '1px solid ' + theme.palette.divider }}
//             >
//               {/* {group.subheader && (
//                 <StyledSubheader disableSticky>{`${translate(group.subheader)}`}</StyledSubheader>
//               )} */}

//               {group.items.map((list) => {
//                 return (
//                   ACCESSIBLE_MENU_URI_LIST.includes(list.path) && (
//                     <NavList
//                       key={list.title + list.path}
//                       data={list}
//                       depth={1}
//                       hasChild={!!list.children}
//                     />
//                   )
//                 );
//               })}
//             </List>
//           )
//         );
//       })}
//     </Stack>
//   );
// }

import { createElement } from 'react';
import { List, Stack, useTheme } from '@mui/material';

import { NavSectionProps } from '../types';

import NavList from './NavList';
import { StyledSubheader } from './styles';

// ----------------------------------------------------------------------

export default function NavSectionVertical({ data, sx, ...other }: NavSectionProps) {
  const theme = useTheme();

  return (
    <Stack sx={sx} {...other}>
      {data.map((group) => {
        const key = group.title || (group.children && group.children[0]?.title);
        return (
          <List
            key={key}
            disablePadding
            sx={{ px: 2, ml: 1, mr: 1, borderBottom: '1px solid ' + theme.palette.divider }}
          >
            {group.title && <StyledSubheader disableSticky>{group.title}</StyledSubheader>}
            {group.children ? (
              group.children.map((list) => (
                <NavList
                  key={list.title + list.path}
                  data={{
                    ...list,
                    icon: list.icon ? createElement(list.icon) : undefined,
                  }}
                  depth={1}
                  hasChild={false}
                />
              ))
            ) : (
              <NavList
                key={group.title + group.path}
                data={{
                  ...group,
                  icon: group.icon ? createElement(group.icon) : undefined,
                }}
                depth={1}
                hasChild={!!group.children}
              />
            )}
          </List>
        );
      })}
    </Stack>
  );
}
